<template>
  <div v-if="user" class="test-match-game-cards-component">
    <div class="match-game__wrapper">
      <NoUserMediaCard :current="current"></NoUserMediaCard>
    </div>
    <div class="match-game__wrapper">
      <NoMoreCard :current="current"></NoMoreCard>
    </div>
    <div class="match-game__wrapper">
      <NoMoreCoinsCard :current="current"></NoMoreCoinsCard>
    </div>
    <div class="match-game__wrapper">
      <NoMoreMatchesCard :current="current"></NoMoreMatchesCard>
    </div>


    <div class="match-game__wrapper">
      <JokerCard :current="current"></JokerCard>
    </div>
    <div class="match-game__wrapper">
      <LikeCard :current="current"></LikeCard>
    </div>
    <hr>
    <div class="match-game__wrapper">
      <LoveCard :current="current" step="DEFAULT"></LoveCard>
    </div>
    <div class="match-game__wrapper">
      <LoveCard :current="current" step="GOOD_ANSWER"></LoveCard>
    </div>
    <div class="match-game__wrapper">
      <LoveCard :current="current" step="WRONG_ANSWER"></LoveCard>
    </div>
  </div>
</template>
<script>

import { mapGetters } from 'vuex';
import JokerCard from '../MatchGame/JokerCard';
import LoveCard from '../MatchGame/LoveCard';
import LikeCard from '../MatchGame/LikeCard';
import NoUserMediaCard from '../MatchGame/NoUserMediaCard';
import NoMoreCard from '../MatchGame/NoMoreCard';
import NoMoreCoinsCard from '../MatchGame/NoMoreCoinsCard';
import NoMoreMatchesCard from '../MatchGame/NoMoreMatchesCard';

export default {
  components: { NoMoreMatchesCard, NoMoreCoinsCard, NoMoreCard, NoUserMediaCard, LikeCard, LoveCard, JokerCard },
  data() {
    return {
      current: {
        profile: {
          id: -100,
          name: 'ProfileName',
          avatar_url: 'https://loremflickr.com/240/240/brazil,rio',
          quiz: {
            question: 'Lubisz ekwilibrystyczne mewy?',
            answers: [
              {
                name: 'Tak',
              }, {
                name: 'Nie',
              }, {
                name: 'A co to znacz?',
              },
            ],
          }
        }
      }
    };
  },
  computed: {
    ...mapGetters('user', {
      user: 'getUser',
    }),
  },
  methods: {},
  mounted() {

  }
};
</script>
